// extracted by mini-css-extract-plugin
export default {"bottomContainer":"BottomButton_bottomContainer__L6jEu"};